import '.a{display:flex;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a9{background-color:var(--shades-white);}.ssr-plugin'
import '.b0{min-height:100vh;}.ssr-plugin'
import '.b1{margin-bottom:2rem;}.ssr-plugin'
import '.b2{max-width:77.5rem;}.ssr-plugin'
import '.b3{margin-bottom:5rem;}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import { ReactNode } from 'react'
import { Style, styled } from 'inlines'
import TopNavBar from '@app/components/blocks/navbar/main/TopNavBar'
import Footer from '@app/components/blocks/footer/Footer'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Head } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { useRootDomain } from '@app/util/hooks/useRootDomain'

export const PageLayout = ({
  gap = '1rem',
  standardPageTitle = true,
  children,
  marginTop = '2rem',
  style,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  standardPageTitle?: boolean
  children: ReactNode
  marginTop?: string
  style?: Style
}) => {
  const isMobile = useMediaQuery()
  const [location] = useLocation()
  const rootDomain = useRootDomain()
  return (
    <styled.div className="a f b e a9"
      style={{
        ...style,
      }}
    >
      {standardPageTitle && (
        <Head>
          <title>CrowdBuilding</title>
        </Head>
      )}
      <Head>
        <link rel="canonical" href={`${rootDomain}${location}`} />
      </Head>
      <TopNavBar />
      <div className="b0 b1 b2"
        style={{
          width: isMobile ? '100%' : '85%',
          paddingInline: isMobile ? '1rem' : 0,
        }}
      >
        <styled.main className="b3 a e a6"
          style={{
            marginTop,
            gap: gap,
            paddingInline: isMobile ? 0 : '1rem',
          }}
        >
          {children}
        </styled.main>

        <Footer />
      </div>
    </styled.div>
  )
}
